import React from "react";
import { Typography, Switch, Button } from "@material-tailwind/react";
import InfoDialog from "components/dialog/info-dialog";
import YouTubeEmbed from "utils/YouTubeEmbed";
import { useFormContext } from "react-hook-form";
import MaterialIcon from "components/material-icon";

export default function ThemingTabHeader({
    survey,
    disabled,
    onToggleGobbyAssist,
    onManageThemes,
}) {
    const { watch } = useFormContext();
    const comprehendEnabled = watch("use_comprehend");

    const canToggleGobby =
    survey?.state === "active" ||
    survey?.state === "paused" ||
    survey?.state === "finished";

    return (
        <div className="flex items-center justify-between pr-4">
            <Button
                className="btn btn--primary"
                onClick={onManageThemes}
            >
                <MaterialIcon name="settings" className="mr-1" />
                Manage Themes
            </Button>
            <div className="flex items-center gap-3 ml-auto">
                <Typography className="text-lg" as="span">Gobby Assist</Typography>
                <Switch
                    color="amber"
                    checked={Boolean(comprehendEnabled)}
                    disabled={!canToggleGobby || disabled}
                    onChange={(e) => {
                        onToggleGobbyAssist(e.target.checked);
                    }}
                />
                <InfoDialog title="Gobby Assist">
                    <div className="text-black">
                        <Typography variant="paragraph">
                            Gobby Assist is an analysis tool which uses Natural Language Processing technology, provided by Amazon Comprehend, to identify keywords used in responses and sentiment. We&apos;ve also created an experimental Gobby Score which can help sort responses to support data analysis. It&apos;s important to remember that if you turn Gobby Assist on, themeable responses will be processed by Amazon Comprehend as a third-party provider. Responses are not used to train Amazon Comprehend. It will just process the responses. But remember, Gobby Assist is optional so you can choose whether to enable it or not.
                        </Typography>
                        <div className="mt-6">
                            <Typography variant="h2" className="mb-2">
                                How to Theme
                            </Typography>
                            <YouTubeEmbed
                                videoId="1KcSzda8Whs"
                                title="How to Theme"
                            />
                            <Typography variant="paragraph" className="mb-2">
                                Responses can be analysed using a range of filters and sorting options. For example, start by filtering by question and sorting responses by Matched Responses (how many times a respondents chose to match an existing response and make it their own) or Sentiment.
                            </Typography>
                            <Typography variant="paragraph" className="mb-2">
                                You can also search responses by key word using the Search field. Filters will appear as &lsquo;breadcrumbs&rsquo; on screen and can be dismissed using the [x].
                            </Typography>
                            <Typography variant="paragraph" className="mb-2">
                                Select responses to add to/create a theme or remove from a theme. Responses can be added to multiple themes where appropriate.
                            </Typography>
                            <Typography variant="paragraph" className="mb-2">
                                If any responses require moderation, search for the response in the Moderation tab. Any moderated responses that have been accepted by the moderator are not themed and excluded from the main report. They remain available to view on the Moderation tab and are included in the All Data .csv download in the Reports tab.
                            </Typography>
                            <Typography variant="paragraph" className="mb-2">
                                All responses should be applied to one or more themes in order to fully represent people&apos;s contributions.
                            </Typography>
                            <Typography variant="paragraph">
                                The button [Clear Filters] will clear all filters.
                            </Typography>
                        </div>
                    </div>
                </InfoDialog>
            </div>
        </div>
    );
}
